export const styles = {
    list: {
        w: "100%",
    },
    divider: {
        borderColor: "gray.100",
    },
};
